var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageLoadErrorImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 198,
    viewBox: "0 0 316 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.5864 120.235C115.788 120.235 142.704 93.3192 142.704 60.1173C142.704 26.9155 115.788 0 82.5864 0C49.3845 0 22.469 26.9155 22.469 60.1173C22.469 93.3192 49.3845 120.235 82.5864 120.235Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.4345C0 36.3076 13.722 54.007 30.6798 54.007L0 14.4345Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6798 54.007C30.6798 31.8881 45.9928 13.9898 64.9167 13.9898L30.6798 54.007Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.116 16.4173C11.116 37.1944 19.8663 54.0069 30.6799 54.0069L11.116 16.4173Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6798 54.007C30.6798 25.7441 48.3793 2.87402 70.2524 2.87402L30.6798 54.007Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2256 54.286C24.2256 54.286 28.5765 54.152 29.8877 53.2183C31.199 52.2845 36.5805 51.1696 36.9058 52.6671C37.2311 54.1646 43.4444 60.115 38.5323 60.1546C33.6201 60.1942 27.1186 59.3894 25.8099 58.5922C24.5012 57.795 24.2256 54.286 24.2256 54.286Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M38.6199 59.6333C33.7078 59.6729 27.2063 58.8682 25.8976 58.071C24.9009 57.4638 24.5037 55.2854 24.3708 54.2803C24.2788 54.2843 24.2256 54.286 24.2256 54.286C24.2256 54.286 24.5012 57.795 25.8099 58.5922C27.1186 59.3894 33.6201 60.1942 38.5323 60.1546C39.9502 60.1431 40.44 59.6386 40.4131 58.8914C40.2161 59.3429 39.6753 59.6248 38.6199 59.6333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0557 126.992C85.2048 126.992 108.835 123.777 108.835 119.811C108.835 115.846 85.2048 112.631 56.0557 112.631C26.9066 112.631 3.27661 115.846 3.27661 119.811C3.27661 123.777 26.9066 126.992 56.0557 126.992Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M56.0557 125.84C80.5285 125.84 100.368 123.141 100.368 119.811C100.368 116.482 80.5285 113.783 56.0557 113.783C31.5829 113.783 11.7438 116.482 11.7438 119.811C11.7438 123.141 31.5829 125.84 56.0557 125.84Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.126 197.286C280.239 197.286 316 192.421 316 186.42C316 180.419 280.239 175.554 236.126 175.554C192.012 175.554 156.251 180.419 156.251 186.42C156.251 192.421 192.012 197.286 236.126 197.286Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6667 188.714C114.166 188.714 135.648 185.792 135.648 182.187C135.648 178.582 114.166 175.659 87.6667 175.659C61.1675 175.659 39.6857 178.582 39.6857 182.187C39.6857 185.792 61.1675 188.714 87.6667 188.714Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.567 176.683C155.969 183.174 204.797 168.216 210.16 151.281",
    stroke: "#2F2E41",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3844 73.1005C87.3844 73.1005 124.076 62.9398 126.334 95.6798C128.592 128.42 96.1339 137.734 121.536 144.225",
    stroke: "#2F2E41",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9357 151.643C51.9357 151.643 62.9635 148.59 63.6421 158.43C64.3208 168.27 54.5654 171.069 62.2 173.02",
    stroke: "#2F2E41",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.783 158.969L217.559 173.165C217.559 173.165 206.613 178.98 214.31 179.151C222.006 179.322 258.264 179.151 258.264 179.151C258.264 179.151 265.276 179.151 254.159 172.994L251.936 158.114L219.783 158.969Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M212.762 178.997C214.509 177.441 217.559 175.821 217.559 175.821L219.783 161.626L251.936 161.656L254.159 175.65C256.752 177.086 258.358 178.186 259.297 179.031C260.725 178.705 262.285 177.494 254.159 172.994L251.936 158.114L219.783 158.969L217.559 173.165C217.559 173.165 208.362 178.052 212.762 178.997Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.026 60.0294H168.351C165.538 60.0294 163.258 62.3098 163.258 65.1227V155.843C163.258 158.656 165.538 160.936 168.351 160.936H303.026C305.839 160.936 308.119 158.656 308.119 155.843V65.1227C308.119 62.3098 305.839 60.0294 303.026 60.0294Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.245 65.4169H168.132V141.011H303.245V65.4169Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.688 63.8776C236.161 63.8776 236.543 63.4947 236.543 63.0224C236.543 62.5501 236.161 62.1673 235.688 62.1673C235.216 62.1673 234.833 62.5501 234.833 63.0224C234.833 63.4947 235.216 63.8776 235.688 63.8776Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.119 146.997V155.843C308.119 156.512 307.987 157.174 307.731 157.792C307.475 158.41 307.1 158.972 306.627 159.445C306.154 159.918 305.593 160.293 304.975 160.549C304.357 160.805 303.695 160.936 303.026 160.936H168.351C167.682 160.936 167.02 160.805 166.402 160.549C165.784 160.293 165.222 159.918 164.749 159.445C164.276 158.972 163.901 158.41 163.645 157.792C163.389 157.174 163.258 156.512 163.258 155.843V146.997H308.119Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.486 188.386V190.097H181.472V188.728L181.599 188.386L183.867 182.229H271.604L273.486 188.386Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.895 186.712C308.728 187.428 308.095 188.184 306.665 188.899C301.534 191.465 291.102 188.215 291.102 188.215C291.102 188.215 283.063 186.847 283.063 183.255C283.289 183.101 283.524 182.961 283.768 182.836C285.925 181.695 293.077 178.879 305.759 182.956C306.694 183.249 307.528 183.796 308.17 184.535C308.684 185.137 309.087 185.9 308.895 186.712Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M308.895 186.712C302.615 189.118 297.018 189.298 291.273 185.308C288.375 183.297 285.743 182.799 283.768 182.837C285.925 181.695 293.078 178.879 305.76 182.956C306.694 183.249 307.528 183.796 308.17 184.535C308.684 185.137 309.087 185.9 308.895 186.712Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.021 185.308C302.249 185.308 303.245 185.002 303.245 184.624C303.245 184.246 302.249 183.94 301.021 183.94C299.793 183.94 298.798 184.246 298.798 184.624C298.798 185.002 299.793 185.308 301.021 185.308Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.688 157.259C237.483 157.259 238.938 155.804 238.938 154.01C238.938 152.215 237.483 150.76 235.688 150.76C233.894 150.76 232.439 152.215 232.439 154.01C232.439 155.804 233.894 157.259 235.688 157.259Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M273.486 188.386V190.097H181.472V188.728L181.599 188.386H273.486Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3601 44.8763H30.6539V113.179H89.3601V44.8763Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2873 38.1025H24.7269V62.3753H95.2873V38.1025Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2873 66.8911H24.7269V91.1639H95.2873V66.8911Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2873 95.6797H24.7269V119.952H95.2873V95.6797Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M81.1752 42.3362H76.6593V46.852H81.1752V42.3362Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M87.6667 42.3362H83.1509V46.852H87.6667V42.3362Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1583 42.3362H89.6425V46.852H94.1583V42.3362Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M81.1752 70.8425H76.6593V75.3584H81.1752V70.8425Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M87.6667 70.8425H83.1509V75.3584H87.6667V70.8425Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1583 70.8425H89.6425V75.3584H94.1583V70.8425Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M81.1752 99.3488H76.6593V103.865H81.1752V99.3488Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M87.6667 99.3488H83.1509V103.865H87.6667V99.3488Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1583 99.3488H89.6425V103.865H94.1583V99.3488Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3602 174.143C101.675 174.143 111.657 164.16 111.657 151.846C111.657 139.531 101.675 129.549 89.3602 129.549C77.0458 129.549 67.0631 139.531 67.0631 151.846C67.0631 164.16 77.0458 174.143 89.3602 174.143Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9733 169.345H79.1995V181.481H85.9733V169.345Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5209 169.345H92.7471V181.481H99.5209V169.345Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8443 183.739C87.9618 183.739 90.4891 182.791 90.4891 181.622C90.4891 180.453 87.9618 179.505 84.8443 179.505C81.7267 179.505 79.1995 180.453 79.1995 181.622C79.1995 182.791 81.7267 183.739 84.8443 183.739Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3919 183.457C101.509 183.457 104.037 182.509 104.037 181.34C104.037 180.171 101.509 179.223 98.3919 179.223C95.2743 179.223 92.7471 180.171 92.7471 181.34C92.7471 182.509 95.2743 183.457 98.3919 183.457Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9246 153.821C94.1333 153.821 97.5451 150.41 97.5451 146.201C97.5451 141.992 94.1333 138.58 89.9246 138.58C85.7159 138.58 82.3041 141.992 82.3041 146.201C82.3041 150.41 85.7159 153.821 89.9246 153.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9246 148.741C91.3275 148.741 92.4648 147.604 92.4648 146.201C92.4648 144.798 91.3275 143.661 89.9246 143.661C88.5217 143.661 87.3844 144.798 87.3844 146.201C87.3844 147.604 88.5217 148.741 89.9246 148.741Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7312 131.11C65.9309 123.047 71.686 114.9 80.5856 112.913C89.4853 110.925 98.1594 115.851 99.9598 123.914C101.76 131.977 95.8621 134.95 86.9624 136.938C78.0627 138.925 69.5316 139.173 67.7312 131.11Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.273 147.399C115.933 144.976 119.905 141.571 119.145 139.794C118.384 138.017 113.179 138.541 107.518 140.964C101.858 143.386 97.8857 146.791 98.6463 148.568C99.4069 150.345 104.612 149.821 110.273 147.399Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.501 162.357C74.1615 159.935 78.1337 156.53 77.3731 154.753C76.6126 152.976 71.4073 153.5 65.7468 155.922C60.0863 158.345 56.1141 161.749 56.8747 163.526C57.6352 165.303 62.8405 164.78 68.501 162.357Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.343 158.337C102.343 160.52 96.7242 164.829 90.4891 164.829C84.254 164.829 78.3528 160.802 78.3528 158.619C78.3528 156.437 84.254 156.926 90.4891 156.926C96.7242 156.926 102.343 156.155 102.343 158.337Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 316,
    height: 197.286,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageLoadErrorImage);
export default __webpack_public_path__ + "static/media/PageLoadErrorImage.fd2b48cd0505a9ab7f1a57cb8d267ffb.svg";
export { ForwardRef as ReactComponent };